import 'reflect-metadata';
import ReactDOM from 'react-dom';
import 'react-reflex/styles.css';
import './index.css';

import { StrictMode } from 'react';
import App from './App';
// import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
